export const AuthTokenKey = 'token';
export const GraphqlEndpoint = 'https://api.marvelapp.com/graphql';
export const clientId = 'YbSWlrvsxuf5B0uez7VbCZ8kPofDUxTuKnCh2hr8';

export const MicrosoftAppId = '2e7fb70e-f75d-4e85-997e-90ce89000f43';
